import { Link } from "react-router-dom";
import { MapPin, Eye, Heart, Star } from "lucide-react";
import { fmtMoney } from "@/lib/format";

export default function ListingCard({ listing, categoryLabel, onToggleFav, isFav }) {
  const cover = listing.photos?.[0];
  const isSold = listing.status === "sold";
  const conditionLabel = {
    new: "Nuevo", like_new: "Como nuevo", used: "Usado",
    refurbished: "Reacond.", n_a: "Servicio",
  }[listing.condition] || "";

  return (
    <article
      data-testid={`listing-${listing.id}`}
      className={`group border hairline bg-cream-card rounded-2xl overflow-hidden hover:shadow-lg transition relative ${isSold ? "opacity-70" : ""}`}
    >
      <Link to={`/marketplace/${listing.id}`} className="block">
        <div className="aspect-[4/3] bg-cream-deep relative overflow-hidden">
          {cover ? (
            <img src={cover} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          ) : (
            <span className="w-full h-full flex items-center justify-center font-mono text-xs uppercase tracking-wider text-ink-mid">Sin imagen</span>
          )}
          {(listing.photos?.length || 0) > 1 && (
            <span className="absolute bottom-2 right-2 bg-ink/80 text-cream text-[10px] font-mono px-2 py-0.5 rounded-full">
              {listing.photos.length} fotos
            </span>
          )}
          {isSold && (
            <span className="absolute top-2 left-2 bg-zinc-900 text-white text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-full">
              Vendido
            </span>
          )}
          {listing.is_promoted && (
            <span className="absolute top-2 right-2 bg-amber-400 text-zinc-900 text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-full inline-flex items-center gap-1">
              <Star className="w-3 h-3" /> Destacado
            </span>
          )}
        </div>
      </Link>

      <div className="p-4">
        <p className="font-mono text-[9px] uppercase tracking-wider text-coral mb-1">
          {categoryLabel} · {listing.type === "service" ? "Servicio" : "Producto"}{conditionLabel ? ` · ${conditionLabel}` : ""}
        </p>
        <Link to={`/marketplace/${listing.id}`} className="block">
          <h3 className="font-medium text-sm leading-snug mb-1 line-clamp-2 group-hover:text-coral transition-colors">
            {listing.title}
          </h3>
        </Link>
        <p className="text-xs text-ink-mid line-clamp-2 mb-2">{listing.description}</p>
        <div className="flex items-center justify-between">
          <span className="font-serif text-xl tracking-tight text-coral" data-testid={`listing-price-${listing.id}`}>
            {fmtMoney(listing.price_usd)}
          </span>
          {listing.location && (
            <span className="text-[11px] text-ink-mid inline-flex items-center gap-0.5">
              <MapPin className="w-3 h-3" />
              {listing.location}
              {listing.distance_km !== null && listing.distance_km !== undefined && (
                <span className="ml-1 text-coral">· {listing.distance_km}km</span>
              )}
            </span>
          )}
        </div>
        <div className="mt-2 flex items-center justify-between">
          <p className="text-[10px] font-mono text-ink-mid inline-flex items-center gap-1">
            <Eye className="w-3 h-3" /> {listing.views} · ❤ {listing.saved_count}
          </p>
          {onToggleFav && (
            <button
              onClick={(e) => { e.preventDefault(); onToggleFav(listing.id); }}
              data-testid={`listing-fav-${listing.id}`}
              className={`p-1.5 rounded-full border hairline transition ${isFav ? "bg-coral text-white border-coral" : "bg-cream hover:border-coral"}`}
              title={isFav ? "Quitar de favoritos" : "Guardar"}
            >
              <Heart className={`w-3.5 h-3.5 ${isFav ? "fill-current" : ""}`} />
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
